import { useState, useCallback } from 'react';
import olreadiaService from '../services/olreadiaService';

const toMessage = (err: any, fallback: string) =>
  err?.response?.data?.message || err?.message || fallback;

export const useServiceOfferings = () => {
  const [offerings, setOfferings] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState({ totalElements: 0, totalPages: 1 });

  const list = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await olreadiaService.serviceOfferings.list(params);
      const content = Array.isArray(res?.content) ? res.content : [];
      setOfferings(content);
      setPage({
        totalElements: res?.totalElements ?? content.length,
        totalPages: res?.totalPages ?? 1,
      });
      return res;
    } catch (err) {
      const message = toMessage(err, 'Failed to load service offerings');
      setError(message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const get = useCallback(async (serviceId: string) => {
    try {
      return await olreadiaService.serviceOfferings.get(serviceId);
    } catch (err) {
      throw err;
    }
  }, []);

  const create = useCallback(async (payload: any, actorId?: string | null) => {
    try {
      return await olreadiaService.serviceOfferings.create(payload, actorId);
    } catch (err) {
      throw err;
    }
  }, []);

  const update = useCallback(async (serviceId: string, payload: any, actorId?: string | null) => {
    try {
      return await olreadiaService.serviceOfferings.update(serviceId, payload, actorId);
    } catch (err) {
      throw err;
    }
  }, []);

  const remove = useCallback(async (serviceId: string, actorId?: string | null) => {
    try {
      await olreadiaService.serviceOfferings.delete(serviceId, actorId);
    } catch (err) {
      throw err;
    }
  }, []);

  return { offerings, loading, error, page, list, get, create, update, remove };
};

export default useServiceOfferings;
